import { useState, useCallback, useRef, useEffect } from 'react';

var useDropdown = function useDropdown() {
  var _a = useState(false),
      isOpen = _a[0],
      setIsOpen = _a[1];

  var ref = useRef(null);
  var open = useCallback(function () {
    return setIsOpen(true);
  }, []);
  var close = useCallback(function () {
    return setIsOpen(false);
  }, []);
  useEffect(function () {
    var handleGlobalMouseDown = function handleGlobalMouseDown(_a) {
      var target = _a.target;
      if (!ref.current || ref.current.contains(target)) return;
      close();
    };

    document.addEventListener('mousedown', handleGlobalMouseDown);
    return function () {
      document.removeEventListener('mousedown', handleGlobalMouseDown);
    };
  }, [close]);
  return [ref, isOpen, open, close];
};

export default useDropdown;